specifierOrString